import React from 'react';
const withouts = ['Inventarios en la sala', 'Ventas por catálogo', 'Jefes ni horarios fijos', 'Cámara ni tu cara visible', 'Software caro ni computadora', 'Experiencia previa en diseño'];
const withs = ['Solo tú, tu móvil y CapCut', 'Clientes que te pagan en dólares', 'Tu horario, tus reglas', 'Trabajo 100% invisible', 'Apps gratuitas que ya tienes', 'Los guiones y estructuras exactas'];
export function Different() {
  return <section className="bg-white py-16 md:py-24" data-id="element-114">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-115">
        <div className="text-center mb-12" data-id="element-116">
          <span className="font-dm text-xs font-bold tracking-widest text-[#c9a84c] uppercase" data-id="element-117">
            Sin lo que te frena
          </span>
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-[#0d4a45] mt-3 leading-tight" data-id="element-118">
            Con lo que necesitas. Sin lo que no.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-119">
          {/* Without */}
          <div className="bg-[#fdf6ee] rounded-2xl p-6 md:p-8 border border-[#e8a0a0]/40" data-id="element-120">
            <h3 className="font-playfair font-bold text-[#0d4a45] text-xl mb-5 flex items-center gap-2" data-id="element-121">
              <span className="text-2xl" data-id="element-122">❌</span> Sin esto
            </h3>
            <ul className="space-y-3" data-id="element-123">
              {withouts.map(item => <li key={item} className="flex items-center gap-3 font-dm text-[#5a5a5a] text-base" data-id="element-124">
                  <span className="w-5 h-5 rounded-full bg-[#e8a0a0]/40 flex items-center justify-center text-xs text-[#d07070] font-bold shrink-0" data-id="element-125">
                    ✕
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          {/* With */}
          <div className="bg-[#0d4a45] rounded-2xl p-6 md:p-8" data-id="element-126">
            <h3 className="font-playfair font-bold text-white text-xl mb-5 flex items-center gap-2" data-id="element-127">
              <span className="text-2xl" data-id="element-128">✅</span> Con esto
            </h3>
            <ul className="space-y-3" data-id="element-129">
              {withs.map(item => <li key={item} className="flex items-center gap-3 font-dm text-white/85 text-base" data-id="element-130">
                  <span className="w-5 h-5 rounded-full bg-[#c9a84c]/30 flex items-center justify-center text-xs text-[#e8c97a] font-bold shrink-0" data-id="element-131">
                    ✓
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom callout */}
        <div className="mt-10 text-center" data-id="element-132">
          <p className="font-playfair italic text-[#0d4a45] text-xl md:text-2xl max-w-2xl mx-auto" data-id="element-133">
            "Sin inventarios, sin ventas por catálogo, sin jefes:{' '}
            <span className="text-[#c9a84c] not-italic font-bold" data-id="element-134">
              Solo tú, tu móvil y CapCut.
            </span>
            "
          </p>
        </div>
      </div>
    </section>;
}